import React from "react"
import { Link } from "gatsby"
import { config } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons"
import { faEnvelope, faAdjust, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons"
import { SEO } from "../utils"
import "../styles/site.css"

// The stylesheet above is imported at build time, so icons must not inject their own.
config.autoAddCss = false

export const GITHUB = "https://github.com/pedrocoutinhosilva"
export const LINKEDIN = "https://www.linkedin.com/in/pedrocoutinhosilva"
export const MAIL = "mailto:pedrocoutinhosilva@gmail.com"

const toggleTheme = () => {
  const root = document.documentElement
  const dark = root.dataset.theme
    ? root.dataset.theme === "dark"
    : window.matchMedia("(prefers-color-scheme: dark)").matches
  root.dataset.theme = dark ? "light" : "dark"
}

export const Layout = ({ title, hero, children }) => (
  <>
    <SEO title={title} />
    <nav>
      <div className="wrap">
        <Link className="brand" to="/">
          pedro<span>.</span>silva
        </Link>
        <div className="links">
          <Link className="hide" to="/projects">Projects</Link>
          <Link className="hide" to="/articles">Talks &amp; writing</Link>
          <Link className="hide" to="/#about">About</Link>
          <button className="theme" onClick={toggleTheme} title="Switch light and dark" aria-label="Switch light and dark">
            <FontAwesomeIcon icon={faAdjust} />
          </button>
        </div>
      </div>
    </nav>
    {hero}
    <main className="wrap">{children}</main>
    <footer>
      <div className="wrap">
        <span>Pedro Coutinho Silva · {new Date().getFullYear()}</span>
        <span>
          <a href={GITHUB}>GitHub</a>
          <a href={LINKEDIN}>LinkedIn</a>
          <a href={MAIL}>Email</a>
        </span>
      </div>
    </footer>
  </>
)

export const Section = ({ id, n, title, children }) => (
  <section id={id}>
    <h2>
      <span className="n">{n}</span> {title}
    </h2>
    {children}
  </section>
)

export const ContactButtons = () => (
  <div className="cta">
    <a className="btn primary" href={MAIL}><FontAwesomeIcon icon={faEnvelope} />Get in touch</a>
    <a className="btn" href={GITHUB}><FontAwesomeIcon icon={faGithub} />GitHub</a>
    <a className="btn" href={LINKEDIN}><FontAwesomeIcon icon={faLinkedin} />LinkedIn</a>
  </div>
)

export const ProjectCard = ({ node, feature }) => {
  const { title, tags, link, repo } = node.frontmatter
  return (
    <a className={feature ? "card feature" : "card"} href={link || repo} target="_blank" rel="noreferrer">
      <h3>
        {title} <FontAwesomeIcon icon={faExternalLinkAlt} />
      </h3>
      <p>{node.excerpt}</p>
      <div className="tags">
        {tags.map(tag => (
          <span className="tag" key={tag}>{tag}</span>
        ))}
      </div>
    </a>
  )
}

const PRESENTATION_TAGS = ["Video", "Talk", "Workshop"]

// Talks and workshops count as presentations even when there is no recording.
export const isPresentation = node =>
  PRESENTATION_TAGS.some(tag => node.frontmatter.tags.includes(tag))

const kindOf = tags =>
  tags.includes("Workshop") ? "workshop"
    : tags.includes("Video") ? "video"
    : tags.includes("Talk") ? "talk"
    : "article"

export const EntryRows = ({ nodes }) => (
  <div className="rows">
    {nodes.map(node => (
      <a className="row" key={node.id} href={node.frontmatter.link} target="_blank" rel="noreferrer">
        <span className="when">{node.frontmatter.date}</span>
        <span className="t">{node.frontmatter.title}</span>
        <span className="kind">{kindOf(node.frontmatter.tags)}</span>
      </a>
    ))}
  </div>
)
